/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Daily_Usage_DescriptionInputs */



/**
* | output |
* | --- |
* | "Daily breakdown of AI usage across all models" |
*
* @param {Dashboard_Daily_Usage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_daily_usage_description = /** @type {((inputs?: Dashboard_Daily_Usage_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Daily_Usage_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tägliche Aufschlüsselung der KI-Nutzung über alle Modelle")
	return /** @type {LocalizedString} */ ("Daily breakdown of AI usage across all models")
});